// @flow

import type {SessionState} from '../types'

export const initialState: SessionState = {
  user: null,
  idToken: null,
  isReady: false,
  isLoading: false,
  error: null,
}
